/**
 * Should never be called, but only throws an exception in dev.
 * @param {never} x
 */
export function assertNever(x) {
  if (process.env.NODE_ENV === 'development') {
    throw new Error(`Unexpected value ${x}`);
  }
}
